"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSubscriptionHandlers = void 0;
var _openProductInfoDialog = _interopRequireWildcard(require("@ori-events/open-product-info-dialog"));
var OpenProductInfoDialog = _openProductInfoDialog;
var _checkoutUtils = require("@ori/checkout-utils");
var _logger = require("@ori/logger");
var _react = require("react");
var _contexts = require("../../contexts");
var _updateBasketItem = require("../../utils/updateBasketItem");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const useSubscriptionHandlers = subscriptionHandlersOptions => {
  const logger = (0, _logger.useLogger)('useSubscriptionHandlers');
  const {
    setIsLoadingAdditionalData,
    isPersonalSubscriptionsEnabled
  } = (0, _contexts.useBasketContext)();
  const {
    itemCode,
    lineNumber,
    originalQuantity,
    placement,
    quantity,
    requestedQuantity
  } = subscriptionHandlersOptions;
  const [subscriptionLineNumber, setSubscriptionLineNumber] = (0, _react.useState)(0);
  const onSubscribeClick = (0, _react.useCallback)(() => {
    const showSubscriptionWizard = new CustomEvent('open-subscription-wizard', {
      detail: {
        type: 'Subscription',
        customerType: 'All',
        productCode: itemCode
      }
    });
    const openProductInfoDialog = new CustomEvent(OpenProductInfoDialog.Name, {
      detail: {
        mode: _openProductInfoDialog.DialogMode.StandardBuy,
        placement: 'quickbuy-basket',
        // TODO: Replace once Placement enum includes this value.
        productCodes: [itemCode],
        lineNumber,
        originalQuantity
      }
    });
    setSubscriptionLineNumber(lineNumber);
    window.dispatchEvent(isPersonalSubscriptionsEnabled ? openProductInfoDialog : showSubscriptionWizard);
    return subscriptionLineNumber;
  }, [isPersonalSubscriptionsEnabled, itemCode, lineNumber, originalQuantity, subscriptionLineNumber]);
  const onSubscriptionSaved = (0, _react.useCallback)(async () => {
    try {
      setIsLoadingAdditionalData(true);
      if (subscriptionLineNumber !== 0) {
        await (0, _updateBasketItem.updateBasketItem)({
          itemCode,
          lineNumber: subscriptionLineNumber,
          placement,
          previousQuantity: requestedQuantity,
          quantity: quantity - 1
        });
      }
    } catch (error) {
      (0, _checkoutUtils.showErrorNotification)();
      logger.error(error);
    } finally {
      setIsLoadingAdditionalData(false);
    }
  }, [setIsLoadingAdditionalData, subscriptionLineNumber, itemCode, placement, requestedQuantity, quantity, logger]);
  return {
    onSubscribeClick,
    onSubscriptionSaved,
    subscriptionLineNumber
  };
};
exports.useSubscriptionHandlers = useSubscriptionHandlers;